module.exports = __webpack_public_path__ + "media/Components/fonts/boldPTSansitalic-928ac59f167f7d14b406664b5e26b314.ttf";